import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-perk',
  templateUrl: './perk.component.html',
  styleUrls: ['./perk.component.scss'],
})
export class PerkComponent {
  perkList = [
    {
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.3.png',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.3.webp',
      imageAlt: 'health insurance',
      text: 'WORK_WITH_US.PERK_SECTION.ITEM.MESSAGE_3',
    },
    {
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.4.png',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.4.webp',
      imageAlt: 'computer for employee',
      text: 'WORK_WITH_US.PERK_SECTION.ITEM.MESSAGE_4',
    },
    {
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.5.png',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.5.webp',
      imageAlt: 'holiday and leave days',
      text: 'WORK_WITH_US.PERK_SECTION.ITEM.MESSAGE_5',
    },
    {
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.6.png',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section8/8.6.webp',
      imageAlt: 'online course',
      text: 'WORK_WITH_US.PERK_SECTION.ITEM.MESSAGE_6',
    },
  ]
  constructor(public translate: TranslateService) {}

}
